var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiamondFilled = function SvgDiamondFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.984 5.333h16.032a1.12 1.12 0 0 1 .91.464l4.3 5.912a.56.56 0 0 1-.042.712l-12.77 13.834a.56.56 0 0 1-.794.032q-.012-.01-12.803-13.867a.56.56 0 0 1-.042-.712l4.3-5.912a1.13 1.13 0 0 1 .909-.463"
  })));
};
export default SvgDiamondFilled;